import { CHAIN_ALIASES } from "src/wallet-connection/chains";
import { NETWORK } from "../constants";
import BscMainnetTokens from "./bscMainnet";
import BscTestnetTokens from "./bscTestnet";

export function getNetworkTokens(network) {
  if (network === NETWORK.BSC_MAINNET) return BscMainnetTokens;
  else if (network === NETWORK.BSC_TESTNET) return BscTestnetTokens;
  else throw Error("Invalid Network!");
}

export function getAssetData(assetAddress, network) {
  const assetList = getNetworkTokens(network);
  return assetList[assetAddress.toLowerCase()];
}

export function getChainAssetData(assetAddress, chainId) {
  if (chainId == CHAIN_ALIASES.BSC_MAINNET) return getAssetData(assetAddress, NETWORK.BSC_MAINNET);
  else if (chainId == CHAIN_ALIASES.BSC_TESTNET) return getAssetData(assetAddress, NETWORK.BSC_TESTNET);
  else throw Error("Invalid Chain!");
}
